import { AppWrapper } from "../../../agent/src/app/AppWrapper";

export function AgentApp() {
  return <AppWrapper />;
}
